/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Groupindex_Description1Inputs */

const en_seo_groupindex_description1 = /** @type {(inputs: Seo_Groupindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse AI tools by group and discover curated collections of categories.`)
};

const zh_seo_groupindex_description1 = /** @type {(inputs: Seo_Groupindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按分组浏览 AI 工具，发现精选的分类合集。`)
};

/**
* | output |
* | --- |
* | "Browse AI tools by group and discover curated collections of categories." |
*
* @param {Seo_Groupindex_Description1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_groupindex_description1 = /** @type {((inputs?: Seo_Groupindex_Description1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Groupindex_Description1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_groupindex_description1(inputs)
	return zh_seo_groupindex_description1(inputs)
});
export { seo_groupindex_description1 as "seo.groupIndex.description" }